/**
 * Scripts Entry Point
 *
 * ブラウザコンソールから実行可能なスクリプト
 */

import seedDashboardData from './seedDashboardData';

// グローバルオブジェクトに登録
if (typeof window !== 'undefined') {
  (window as unknown as Record<string, unknown>).RipiaScripts = {
    seedDashboardData,
  };

  console.log('🚀 Ripia Scripts loaded!');
  console.log('');
  console.log('📦 利用可能なスクリプト:');
  console.log(
    '  RipiaScripts.seedDashboardData()       // ダッシュボードデータ投入'
  );
  console.log('  RipiaScripts.seedDashboardData(true)   // 既存データを上書き');
  console.log('');
}

export { seedDashboardData };
